import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";

// Utils
import dataHandler from "@Utils/dataHandler";

// Styles
import styles from "./styles.module.css";

const UserForHours = ({ dispatch, userName, companyName, onOpenFilterModal, appliedFilters = {} }) => {
	const defaultParams = { page: 1, orderKey: "closeDate", orderDir: "asc", rows: 20 };
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [lastParams, setLastParams] = useState(defaultParams);
	const [sumData, setSumData] = useState({});

	useEffect(() => {
		const mergedParams = { ...defaultParams, ...appliedFilters, groupBy: "userId" };

		(async () => {
			try {
				const response = await dataHandler({
					dispatch,
					method: "GET",
					url: "/reports/historic/summary/hour",
					params: mergedParams,
				});

				setFilteredItems(response.items);
				setFilteredCount(response.count);
				setSumData(response.total || {});
				setLastParams(mergedParams);
			} catch (error) {
				setFilteredItems([]);
				setFilteredCount(0);
				setSumData({});
			}
		})();
	}, [appliedFilters]);

	const handlerData = async (params = defaultParams, printable) => {
		const mergedParams = {
			...params,
			...appliedFilters,
			fields: "user.fullName,closeDate",
			groupBy: "userId",
		};

		const data = await dataHandler({
			method: "GET",
			dispatch,
			url: "/reports/historic/summary/hour",
			params: mergedParams,
		});

		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setLastParams(mergedParams);
			setSumData(data.total || {});
		}
	};

	const handleRefreshData = () => {
		handlerData(lastParams);
	};

	const renderTopButtons = () => {
		const buttons = [
			{
				icon: "filter",
				className:
					Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0
						? styles.filterButtonActive
						: styles.filterButton,
				onClick: onOpenFilterModal,
				content: Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0 ? "Filtrando" : "",
				label: Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0 ? "Filtrando" : "",
				showLabel: true,
				componentType: "button",
			},
			{
				icon: "refresh",
				className: styles.refreshButton,
				onClick: handleRefreshData,
			},
		];

		const filters = typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {};
		const dateRange = filters.createdDate || filters.closeDate;
		if (dateRange) {
			const formatDate = (d) => {
				if (!d) return "";
				const parts = d.split("-");
				if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
				return d;
			};
			const [start, end] = dateRange.split(",");
			let value = formatDate(start);
			const today = new Date();
			const currentEnd =
				end || `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
			if (currentEnd && start !== currentEnd) value += ` al ${formatDate(currentEnd)}`;

			buttons.push({
				componentType: "Label",
				title: "Fecha:",
				value,
			});
		}

		return buttons;
	};

	return (
		<div className={styles.container}>
			<div className={styles.containerTableGroup}>
				<div className={styles.tableGroupList}>
					<IkTable
						data={filteredItems}
						columns={[
							{
								label: "Fecha",
								key: "closeDate",
								format: "date",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "Usuarios",
								key: "user.fullName",
								format: "string",
								headerPosition: "center",
								dataPosition: "left",
								width: 1,
							},
							{
								label: "Total",
								key: "total",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "6am",
								key: "hour6",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "7am",
								key: "hour7",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "8am",
								key: "hour8",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "9am",
								key: "hour9",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "10am",
								key: "hour10",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "11am",
								key: "hour11",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "12pm",
								key: "hour12",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "1pm",
								key: "hour13",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "2pm",
								key: "hour14",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "3pm",
								key: "hour15",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "4pm",
								key: "hour16",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "5pm",
								key: "hour17",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "6pm",
								key: "hour18",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "7pm",
								key: "hour19",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "8pm",
								key: "hour20",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "9pm",
								key: "hour21",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "10pm",
								key: "hour22",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "11pm",
								key: "hour23",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "12am",
								key: "hour0",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "1am",
								key: "hour1",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "2am",
								key: "hour2",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "3am",
								key: "hour3",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "4am",
								key: "hour4",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "5am",
								key: "hour5",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
						]}
						totalRows={filteredCount}
						filteredPrintData={filteredPrintData}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						print={{
							printHeader: {
								company: companyName,
								title: "Hora/Usuarios",
								user: userName,
							},
						}}
						searcher={{
							searchable: true,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						widthAuto
						topButtons={renderTopButtons()}
						sumData={sumData}
					/>
				</div>
			</div>
		</div>
	);
};

function mapStateToProps({ user, company }) {
	return {
		userName: user.name,
		companyName: company.name,
	};
}

UserForHours.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
	onOpenFilterModal: PropTypes.func,
	appliedFilters: PropTypes.object,
};

export default connect(mapStateToProps)(UserForHours);
